import { collection, getDocs, query, where } from "firebase/firestore";
import React from "react";
import { db } from "../../firebase";

const GetAllParents = async () => {
  let UsersRef = collection(db, "Users");
  let Parents = [];
  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);

  const q = query(
    UsersRef,
    where("UserType", "==", "parent"),
    where("IsVerified", "==", 1),
    where("SchoolID", "==", schoolId)
  );
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    Parents.push({
      id: doc.id,
      ...doc.data(),
    });
  });

  return Parents;
};

export default GetAllParents;
